import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SunIcon, HeartIcon, ShieldIcon, PhoneIcon } from 'lucide-react';
export function DiscountsSection() {
  const discounts = [{
    title: 'Summer Time Discount',
    offer: 'GET UP TO Summer Time Discount',
    icon: SunIcon,
    color: 'from-amber-400 to-orange-500',
    iconBg: 'bg-amber-100 text-amber-600'
  }, {
    title: 'Senior Citizen Discount',
    offer: 'Summer Time Discount',
    icon: HeartIcon,
    color: 'from-rose-400 to-red-500',
    iconBg: 'bg-rose-100 text-rose-600'
  }, {
    title: 'Military Discount',
    offer: 'Summer Time Discount',
    icon: ShieldIcon,
    color: 'from-blue-400 to-indigo-500',
    iconBg: 'bg-blue-100 text-blue-600'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-brand-navy relative overflow-hidden" data-id="element-87">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-88"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-red/20 rounded-full blur-3xl" data-id="element-89"></div>
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-brand-blue/20 rounded-full blur-3xl" data-id="element-90"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center gap-3 mb-4" data-id="element-93">
            <div className="h-[2px] w-8 bg-brand-red" data-id="element-94"></div>
            <span className="text-brand-red font-bold tracking-wider text-sm uppercase" data-id="element-95">
              Special Offers
            </span>
            <div className="h-[2px] w-8 bg-brand-red" data-id="element-96"></div>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-6" data-id="element-97">
            Available Discounts
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-98">
          {discounts.map((discount, index) => <motion.div key={index} variants={cardVariants} className="bg-white rounded-3xl p-8 shadow-xl relative overflow-hidden group hover:-translate-y-2 transition-transform duration-300" data-id="element-99">
              {/* Top color bar */}
              <div className={`absolute top-0 left-0 right-0 h-2 bg-gradient-to-r ${discount.color}`} data-id="element-100"></div>

              <div className={`w-16 h-16 rounded-2xl ${discount.iconBg} flex items-center justify-center mb-6 shadow-sm`} data-id="element-101">
                <discount.icon className="w-8 h-8" data-id="element-102" />
              </div>

              <h3 className="text-2xl font-bold text-brand-navy mb-2" data-id="element-103">
                {discount.title}
              </h3>
              <p className="text-brand-charcoal/70 font-medium mb-8" data-id="element-104">
                {discount.offer}
              </p>

              <div className="mt-auto pt-6 border-t border-gray-100" data-id="element-105">
                <p className="text-sm text-brand-charcoal/50 mb-2 uppercase tracking-wider font-bold" data-id="element-106">
                  Call to redeem
                </p>
                <a href="tel:+18003954459" className="flex items-center gap-2 text-xl font-extrabold text-brand-red hover:text-red-700 transition-colors group/link" data-id="element-107">
                  <PhoneIcon className="w-5 h-5 group-hover/link:animate-bounce" data-id="element-108" />
                  1(800)-395-4459
                </a>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}